import TextNodeConverter from '../TextNodeConverter'

export default TextNodeConverter.extend({
  type: 'label',
  tagName: 'label'
})
